import React, { useState, useEffect, useRef } from "react";
import { withSnackbar } from "notistack";
import { Grid } from "@material-ui/core";
import SvSearchBar from "../components/SvSearchBar";
import SvTable from "../components/SvTable";
import { permissionCheckFnforCamo, downloadFileType } from "../../../../utils";
import { SvTableHead } from "./SvTableHead";
import { AccessDenied, EmptyCollection, PageLoader, DeletePopUp } from "../../../../shared_elements";
import SvList from "../components/SvList";
import { onArchiveAsset } from "../apiServices";
import BasicDetailHeader from "../../BasicDetailHeader";
import { trackActivity } from "../../../../utils/mixpanel";
import { globalDeleteService, globalGetService, globalExportService, globalFileUploadService, globalPutService } from "../../../../utils/globalApiServices";
import moment from "moment";
import JSZip from 'jszip';
import { saveAs } from 'file-saver';
import SubDetails from "../../../../shared_elements/components/sub_details/SubDetails";

const ShopVisitComponents = (props) => {
	const [pageLoader, setPageLoader] = useState(false);
	const [tabIndex] = useState(0);
	const [sort, setSort] = useState("");
	const [sortBy, setSortBy] = useState("");
	const [filter, setFilter] = useState({});
	const [assetsDetail, setAssetsDetail] = useState({
		list: [],
		pagination: {},
		new_task_last_used_folder_uuid: '',
		last_used_folder_uuid_link_document: "",
		checkbox_last_used_folder_uuid: '',
		checkbox_last_used_folder_name: ''
	});
	const [currentRecordPerPage, setCurrentRecordPerPage] = useState(50);
	const [uuid, setUuid] = useState("");
	const [slug, setSlug] = useState('');
	const [bulkOperation, setBulkOperation] = useState({ modal: false, ids: [], title: '', type: '' });
	const [basicDetail, setBasicDetail] = useState({});
	const [techSpecDetail, setTechSpecDetail] = useState({});
	const [basicDetails, setBasicDetails] = useState({});
	const [archiveModal, setArchiveModal] = useState(false);
	const [isBasicDetailExpanded, setIsBasicDetailExpanded] = useState(true);

	// Ref so async callbacks always read the latest value without stale closure
	const currentRecordPerPageRef = useRef(currentRecordPerPage);
	useEffect(() => { currentRecordPerPageRef.current = currentRecordPerPage; }, [currentRecordPerPage]);

	const getShopVisitData = async (queryParams = {}, loaderType, searchString = null) => {
		setPageLoader(true);
		const { asset, assetType: assetTypeParam } = props.match.params;
		try {
			const response = await globalGetService(`camo/shop/`, {
				...queryParams,
				per_page: queryParams.per_page || 50,
				asset,
				asset_type: assetTypeParam,
				search: searchString,
			});

			if (response?.status === 500) {
				props.enqueueSnackbar("Something went wrong.", { variant: "error", anchorOrigin: { vertical: "top", horizontal: "right" } });
				return null;
			}

			setPageLoader(false);

			const { page, per_page, asset_type, sort: _sort, sort_by: _sort_by, ...remainingFilter } = queryParams;
			setFilter(remainingFilter);

			setAssetsDetail({
				list: response?.data?.results,
				pagination: {
					total: response?.data?.pagination?.total,
					per_page: response?.data?.pagination?.per_page,
					page: parseInt(response?.data?.pagination?.current_page),
				},
				new_task_last_used_folder_uuid: response?.data?.new_task_last_used_folder_uuid,
				last_used_folder_uuid_link_document: response?.data?.last_used_folder_uuid_link_document,
				checkbox_last_used_folder_uuid: response?.data?.checkbox_last_used_folder_uuid,
				checkbox_last_used_folder_name: response?.data?.checkbox_last_used_folder_name,
			});
			return response;
		} catch (error) {
			console.error("Error fetching data:", error);
			return null;
		}
	};

	useEffect(() => {
		getShopVisitData({ per_page: 50 });
		trackActivity('Shop Vists Page Visited - CAMO', {
			event_type: 'Page Visited',
			page_title: 'Shop Vists',
		});
	}, []); // eslint-disable-line react-hooks/exhaustive-deps

	const handleDeleteRow = (item, per_page) => {
		globalDeleteService(`camo/shop/${item.id}/`).then((response) => {
			if (response.status === 200) {
				props.enqueueSnackbar("Record Deleted Successfully", { variant: "success", anchorOrigin: { vertical: "top", horizontal: "right" } });
			}
			if (response.status === 500) {
				props.enqueueSnackbar("Something went wrong.", { variant: "error", anchorOrigin: { vertical: "top", horizontal: "right" } });
			}
			getShopVisitData({ per_page });
		});
	};

	const updateFormData = async (updateId, updatedData, close, formclose) => {
		setPageLoader(true);
		globalPutService(`camo/shop/${updateId}/`, updatedData).then((response) => {
			if (response?.status === 500 || response.data?.statusCode === 500) {
				setPageLoader(false);
				props.enqueueSnackbar(
					response.data?.statusCode === 500 ? response.data?.message : "Something went wrong.",
					{ variant: "error", anchorOrigin: { vertical: "top", horizontal: "right" } }
				);
				close();
			} else if (response) {
				setPageLoader(false);
				props.enqueueSnackbar("Record Updated Successfully", { variant: "success", anchorOrigin: { vertical: "top", horizontal: "right" } });
				formclose();
				getShopVisitData({ per_page: currentRecordPerPageRef.current });
			}
		});
	};

	const fileUploadData = (uploadId, formdata, haveAttachments) => {
		setPageLoader(true);
		if (haveAttachments) {
			globalFileUploadService(`camo/attachment/upload/`, formdata)
				.then((response) => {
					if (response.status === 500) {
						props.enqueueSnackbar("Something went wrong.", { variant: "error", anchorOrigin: { vertical: "top", horizontal: "right" } });
					} else {
						if (response?.data?.statusCode === 200) {
							setPageLoader(false);
						}
						getShopVisitData({ per_page: currentRecordPerPageRef.current });
					}
				})
				.catch(console.error);
		} else {
			props.enqueueSnackbar("Data Submitted Successfully", { variant: "success", anchorOrigin: { vertical: "top", horizontal: "right" } });
			getShopVisitData({ per_page: currentRecordPerPageRef.current });
		}
	};

	const importFile = (formData, isXLSX) => {
		if (isXLSX) {
			setPageLoader(true);
			const { asset, assetType: assetTypeParam } = props.match.params;
			globalFileUploadService(`camo/shop/${asset}/${assetTypeParam}/import/`, formData)
				.then((response) => {
					setPageLoader(false);
					if (response?.data?.statusCode === 200) {
						trackActivity("Shop Visit Import  Successfully - CAMO ", { page_title: "Shop Visit Import " });
						props.enqueueSnackbar(response?.data?.message, { variant: "success", anchorOrigin: { vertical: "top", horizontal: "right" } });
					} else {
						trackActivity("Shop Visit Import Failed - CAMO ", { page_title: "Shop Visit Import Failed" });
						props.enqueueSnackbar(response?.data?.message, { variant: "error", anchorOrigin: { vertical: "top", horizontal: "right" } });
					}
					getShopVisitData({ per_page: currentRecordPerPageRef.current });
				})
				.catch((err) => {
					console.error(err);
					props.enqueueSnackbar("Please import proper file", { variant: "error", anchorOrigin: { vertical: "top", horizontal: "right" } });
				});
		} else {
			props.enqueueSnackbar("Please Import only .XLSX File", { variant: "error", anchorOrigin: { vertical: "top", horizontal: "right" } });
		}
	};

	const exportAssetDetailListFunc = (queryParams) => {
		setPageLoader(true);
		const todayeDate = moment().format("YYYY-MM-DD");
		const { asset, assetType: assetTypeParam } = props.match.params;
		const exportParams = { ...queryParams };
		delete exportParams.asset_type;
		globalExportService(`/camo/shop/${asset}/${assetTypeParam}/export/`, exportParams).then((response) => {
			if (response.status === 500) {
				props.enqueueSnackbar("Something went wrong.", { variant: "error", anchorOrigin: { vertical: "top", horizontal: "right" } });
			} else {
				setPageLoader(false);
				downloadFileType(response.data, `${todayeDate}_ESN${basicDetails?.esn || basicDetails?.msn}_ShopVisits`, queryParams.download);
				props.enqueueSnackbar("Download of Shop Visit List successful", { variant: "success", anchorOrigin: { vertical: "top", horizontal: "right" } });
				trackActivity("Shop Visit Exported - CAMO ", { page_title: "Shop Visit Listing" });
			}
		});
	};

	const exportMasterApiFunc = (queryParams) => {
		setPageLoader(true);
		const todayeDate = moment().format("DD-MM-YYYY");
		const { asset, assetType: assetTypeParam } = props.match.params;
		globalExportService(`/camo/smbc_master_excel/${asset}/${assetTypeParam}/export/`).then((response) => {
			if (response.status === 500) {
				props.enqueueSnackbar("Something went wrong.", { variant: "error", anchorOrigin: { vertical: "top", horizontal: "right" } });
			} else {
				setPageLoader(false);
				downloadFileType(response.data, `Master_Export_${todayeDate}`, queryParams.download);
				props.enqueueSnackbar("Master Export Download Successfully", { variant: "success", anchorOrigin: { vertical: "top", horizontal: "right" } });
				trackActivity("Master Export", { page_title: "Asset Listing" });
			}
		});
	};

	const downloadAllFilesApi = async (queryParams) => {
		setPageLoader(true);
		const attachment_list = queryParams.item.download_attachments;
		for (let i = 0; i < attachment_list.length; i++) {
			attachment_list[i][1] = decodeURIComponent(attachment_list[i][1]);
		}
		const zip = new JSZip();
		const folder = zip.folder('DownloadedFiles');
		try {
			const downloadPromises = attachment_list.map(async ([name, url]) => {
				const res = await fetch(url || '');
				if (!res.ok) throw new Error(`HTTP error! Status: ${res.status}`);
				folder.file(name, await res.blob());
			});
			await Promise.all(downloadPromises);
			const content = await zip.generateAsync({ type: 'blob' });
			saveAs(content, 'Shop Visit.zip');
			setPageLoader(false);
		} catch (error) {
			console.error('Error:', error);
		}
	};

	const bulkDeleteFn = () => {
		setPageLoader(true);
		const { asset, assetType: assetTypeParam } = props.match.params;
		globalDeleteService(`camo/shop/bulk_delete/${assetTypeParam}/${asset}/`, {
			delete_ids: bulkOperation.ids.map(item => item.id)
		}).then((response) => {
			if (response?.data?.statusCode === 200) {
				setPageLoader(false);
				trackActivity("Shop Visit Bulk Deleted Success - CAMO", { page_title: "Shop Visit Listing" });
				props.enqueueSnackbar(response?.data?.message, { variant: "success", anchorOrigin: { vertical: "top", horizontal: "right" } });
			} else {
				trackActivity("Shop Visit Bulk Deleted Failed - CAMO", { page_title: "Shop Visit Listing" });
				props.enqueueSnackbar(response?.data?.message, { variant: "error", anchorOrigin: { vertical: "top", horizontal: "right" } });
			}
			getShopVisitData({ per_page: assetsDetail.pagination.per_page });
			setBulkOperation({ modal: false, ids: [], title: '', type: '' });
		});
	};

	const createSortHandler = (sortField) => {
		if (sortField === sort) {
			const newSortBy = sortBy === "asc" ? "desc" : "asc";
			setSort(sortField);
			setSortBy(newSortBy);
			getShopVisitData({ ...filter, sort: sortField, sort_by: newSortBy, per_page: assetsDetail.pagination.per_page, asset_type: tabIndex });
		} else {
			setSort(sortField);
			setSortBy("desc");
			getShopVisitData({ ...filter, sort: sortField, sort_by: "asc", per_page: assetsDetail.pagination.per_page, asset_type: tabIndex });
		}
	};

	const toggleBulkOps = async (flag, type, item) => {
		try {
			if (type === 'bulk') {
				const response = await getShopVisitData({ per_page: assetsDetail?.pagination?.total }, "skeletonLoader", null);
				setBulkOperation(prev => ({ ...prev, type: 'bulk', ids: flag ? response?.data?.results : [] }));
			} else {
				setBulkOperation(prev => ({
					...prev,
					type: 'single',
					ids: flag ? [...prev.ids, item] : prev.ids.filter(optionItem => optionItem.id !== item.id)
				}));
			}
		} catch (error) {
			console.error("Error fetching data:", error);
		}
	};

	return (
		<section className="amp-listing-section">
			{pageLoader ? <PageLoader /> : null}
			<Grid className="mt-0" spacing={3} container>
				<Grid className="pt-0 pr-0" xs={12} item>
					<SubDetails
						masterExport={true}
						title="Shop Visits"
						slug={slug}
						module='sv'
						match={props.match}
						onRefresh={()=>getShopVisitData()}
						permissionCheck={permissionCheckFnforCamo({ primaryKey: "ad_status", keyIndex: "U" })}
					/>
					<BasicDetailHeader
						props={props}
						func={(slug) => setSlug(slug)}
						uuid={(id) => setUuid(id)}
						engineType={(data) => setBasicDetails(data)}
						module='sv'
						basicData={(data, techspec) => { setBasicDetail(data); setTechSpecDetail(techspec); }}
						svData={assetsDetail}
						onAccordionChange={(expanded) => setIsBasicDetailExpanded(expanded)}
					/>
					{permissionCheckFnforCamo({ primaryKey: "ad_status", keyIndex: "R" }) ? (
						<div className="custom-border">
							<SvSearchBar
								svDetail={assetsDetail?.list}
								basicDetail={basicDetail}
								techSpecDetail={techSpecDetail}
								currentRecordPerPage={currentRecordPerPage}
								tabIndex={tabIndex}
								pageLoader="pageLoader"
								props={props}
								uuid={uuid}
								basicDetails={basicDetails}
								importFile={(formData, _props, isXLSX) => importFile(formData, isXLSX)}
								getResponseBack={() => getShopVisitData({ per_page: currentRecordPerPage })}
								fileUploadData={(uploadId, formdata, _props, haveAttachments) => fileUploadData(uploadId, formdata, haveAttachments)}
								searchData={(e) => {
									const val = e.target.value;
									if (val !== null) getShopVisitData({ per_page: currentRecordPerPage }, "skeletonLoader", val);
								}}
								exportReportFn={(file) => exportAssetDetailListFunc({ download: file.extension })}
							/>
							<SvTable
								currentRecordPerPage={currentRecordPerPage}
								heads={SvTableHead}
								sort={sort}
								basicDetails={basicDetails}
								sort_by={sortBy}
								isBasicDetailExpanded={isBasicDetailExpanded}
								bulkDeletefn={bulkDeleteFn}
								bulkOperation={bulkOperation}
								bulkFlag={assetsDetail?.list?.length === bulkOperation?.ids?.length && assetsDetail?.list?.length > 0}
								toggleBulkOps={(flag) => toggleBulkOps(flag, 'bulk')}
								data={assetsDetail?.list?.map((item, index) => (
									<SvList
										key={index}
										svDetail={assetsDetail?.list}
										basicDetail={basicDetail}
										techSpecDetail={techSpecDetail}
										bulkOperation={bulkOperation}
										toggleBulkOps={(flag) => toggleBulkOps(flag, 'single', item)}
										currentRecordPerPage={currentRecordPerPage}
										item={item}
										uuid={uuid}
										basicDetails={basicDetails}
										assetsDetail={assetsDetail}
										getResponseBack={() => getShopVisitData({ per_page: currentRecordPerPage })}
										last_used_folder_uuid={assetsDetail.new_task_last_used_folder_uuid}
										last_used_folder_uuid_link_document={assetsDetail.last_used_folder_uuid_link_document}
										checkbox_last_used_folder_uuid={assetsDetail.checkbox_last_used_folder_uuid}
										checkbox_last_used_folder_name={assetsDetail.checkbox_last_used_folder_name}
										index={index}
										handleDeleteRow={() => handleDeleteRow(item, currentRecordPerPage)}
										updateFormData={(updateId, updatedData, _props, close, formclose) => updateFormData(updateId, updatedData, close, formclose)}
										props={props}
										fileUploadData={(uploadId, formdata, _props, haveAttachments) => fileUploadData(uploadId, formdata, haveAttachments)}
										downloadAllApi={(file) => downloadAllFilesApi({ download: file.extension, asset_type: tabIndex, item })}
									/>
								))}
								createSortHandler={createSortHandler}
								pagination={assetsDetail.pagination}
								onChangePage={(event, newPage) =>
									getShopVisitData({
										asset_type: tabIndex,
										per_page: assetsDetail.pagination.per_page,
										page: newPage + 1,
									})
								}
								onChangeRowsPerPage={(event) => {
									const newPerPage = event.target.value;
									setCurrentRecordPerPage(newPerPage);
									getShopVisitData({ asset_type: tabIndex, per_page: newPerPage });
								}}
								noRecord={
									assetsDetail?.list?.length ? null : !pageLoader ? (
										<EmptyCollection title="No Records Found" />
									) : null
								}
							/>
						</div>
					) : (
						<AccessDenied />
					)}
				</Grid>
			</Grid>
			{archiveModal && (
				<DeletePopUp
					title='Archive Asset'
					deleteRecordFn={() => onArchiveAsset(props, slug)}
					modal={() => setArchiveModal(true)}
					content='Are you sure, you want to Archive?'
					toggleModalFn={() => setArchiveModal(false)}
					confirmText="ARCHIVE"
				/>
			)}
		</section>
	);
};

export default withSnackbar(ShopVisitComponents);
